import { Navigate } from 'react-router-dom';

/**
 * F5-T6c · Admin 12 — la pantalla suelta de subida MUERE por contrato («las
 * dos pantallas sueltas» se fusionan): subir un lote vive en el modal de dos
 * pasos de «Lotes de pacientes». La ruta /admin/batches/upload se conserva
 * (AdminShell no se toca en esta tanda) y redirige a la fusión abriendo el
 * modal. El flujo de subida (preview dry-run → confirmar, misma TX síncrona)
 * vive intacto en BatchesListPage.
 */
export function BatchUploadPage(): JSX.Element {
  return <Navigate to="/admin/batches?upload=1" replace />;
}
